import { AppProvider, useApp } from '@/context/AppContext';
import AuthGate from '@/screens/auth/AuthGate';
import DesktopLayout from '@/layouts/DesktopLayout';
import MobileLayout from '@/layouts/MobileLayout';
import EstimatePortal from '@/screens/public/EstimatePortal';

function AppShell() {
  const { isMobile } = useApp();
  return isMobile ? <MobileLayout /> : <DesktopLayout />;
}

// Match public routes BEFORE AuthGate so unauthenticated homeowners can reach
// /estimate/:token (and future /pay/:token) without bouncing through login.
function matchPublicRoute(pathname) {
  const m = pathname.match(/^\/estimate\/([0-9a-f-]{8,})\/?$/i);
  if (m) return { type: 'estimate', token: m[1] };
  return null;
}

export default function App() {
  const route = matchPublicRoute(typeof window !== 'undefined' ? window.location.pathname : '/');
  if (route?.type === 'estimate') {
    return <EstimatePortal token={route.token} />;
  }
  return (
    <AuthGate>
      {({ userId, email }) => (
        <AppProvider userId={userId} userEmail={email}>
          <AppShell />
        </AppProvider>
      )}
    </AuthGate>
  );
}
